import { createStore } from 'redux'
import companyUsersReducer from '../reducers/companyUsers'

export default (initialState) => createStore(companyUsersReducer, initialState)



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/store/configureStore.js